import React from "react";
import LaravelSkillSvg from "../assets/images/svg/laravel-skill.svg";
import NodejsSkillSvg from "../assets/images/svg/nodejs-skill.svg";
import DockerSkillSvg from "../assets/images/svg/docker-skill.svg";
import CicdSkillSvg from "../assets/images/svg/cicd-skill.svg";
import DatabaseSkillSvg from "../assets/images/svg/database-skill.svg";

const Resume = () => {
  return (
    <>
      {/* <!-- ====================================== Section Education Experience ===================================== --> */}
      <section className="education-experience" id="resume">
        <div className="row">
          <div className="col-12">
            <div className="heading-container">
              <h2 className="section-heading-text about-me fade_up">
                Experience.
              </h2>
              <div className="line"></div>
            </div>
            <div className="education position-relative fade_up">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">Tech Lead Engineer (WMS & TMS)</p>
                <p className="cursus university">
                  WZ Technology / March 2024 - Present
                </p>
                <p className="cursus">
                  Spearheaded enterprise WMS/TMS architecture and delivery;
                  improved throughput by 35%, led a 4-person team, and
                  implemented CI/CD and infrastructure practices to support
                  high-volume logistics operations.
                </p>
              </div>
            </div>
            <div className="education position-relative fade_up">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">Software Engineer</p>
                <p className="cursus university">
                  WZ Technology / February 2023 - March 2024
                </p>
                <p className="cursus">
                  Built webhook integration (Laravel) processing 5,000+ daily
                  transactions, maintained and scaled core WMS (Yii), and
                  delivered middleware services (Node.js/Express + Laravel)
                  connecting third-party systems.
                </p>
              </div>
            </div>
            <div className="education position-relative fade_up">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">Fullstack Web Developer (Part-Time)</p>
                <p className="cursus university">
                  Specta Creative / April 2019 - Present
                </p>
                <p className="cursus">
                  Delivered Laravel apps including pharmacy e-commerce with
                  Tokopedia API integration, reporting dashboards + secure
                  REST APIs, GitHub Actions deployments to VPS, and interactive
                  web experiences.
                </p>
              </div>
            </div>
            <div className="education position-relative fade_up">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">Fullstack Developer</p>
                <p className="cursus university">
                  Elisoft Technology / December 2020 - December 2022
                </p>
                <p className="cursus">
                  Built monolithic transportation management apps (Laravel +
                  Vue.js), created reservation/RSVP systems, and integrated the
                  Jitsi library for real-time meetings and video conferencing.
                </p>
              </div>
            </div>
            <div className="education position-relative fade_up">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">Junior Software Engineer</p>
                <p className="cursus university">
                  Goodeva Technology / September 2018 - December 2018
                </p>
                <p className="cursus">
                  Built backend + reporting dashboards (Laravel) and secure
                  REST APIs for mobile apps, plus internal tools (POS and todo)
                  to streamline daily operations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- ====================================== Section Education Experience End ===================================== --> */}
      {/* <!-- ====================================== Section Coding Skill ===================================== --> */}
      <section className="coding-skill-section">
        <div className="heading-container">
          <h2 className="section-heading-text coding-skill-text fade_up">
            Coding Skills.
          </h2>
          <div className="line"></div>
        </div>
        <div className="design-skill-sub-section">
          <div className="design-skills-img-main flip_up">
            <img src={LaravelSkillSvg} alt="laravel" />
            <div className="skill-counter-main">
              <p>Laravel</p>
            </div>
          </div>
          <div className="design-skills-img-main photoshop flip_up">
            <img src={NodejsSkillSvg} alt="nodejs" />
            <div className="skill-counter-main photoshop-text">
              <p>Node.js</p>
            </div>
          </div>
          <div className="design-skills-img-main adobe-xd flip_up">
            <img src={DockerSkillSvg} alt="docker" />
            <div className="skill-counter-main adobe-xd-text">
              <p>Docker</p>
            </div>
          </div>

          <div className="design-skills-img-main sketch flip_up">
            <img src={CicdSkillSvg} alt="cicd" />
            <div className="skill-counter-main sketch-text">
              <p>CI/CD</p>
            </div>
          </div>
          <div className="design-skills-img-main invision flip_up">
            <img src={DatabaseSkillSvg} alt="databases" />
            <div className="skill-counter-main invision-text">
              <p>Databases</p>
            </div>
          </div>
        </div>
        <p className="molestie fade_up">
          Also working with: Vue.js, Yii, MySQL, PostgreSQL, Redis, Nginx,
          GitHub Actions.
        </p>
      </section>
      {/* <!-- ====================================== Section Coding Skill End ===================================== --> */}
    </>
  );
};
export default Resume;
